import { Modal } from 'antd'
import React from 'react'
import { GetData } from '../../api/service';
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
const handleDragStart = (e) => e.preventDefault();

export default function HomePageFeatured() {

    const [visible, setIsVisible] = React.useState(false)

    const [data, setData] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(false);

    React.useEffect(() => {
        setTimeout(() => loadData(), 5000)
    }, [])

    function loadData(){
        GetData(`/getfeaturednotificationwebsite`)
            .then((resp) => {
                if (resp.length > 0) {
                    setData(resp[0])

                    setIsLoaded(true)
                    setIsVisible(true)
                }

            })
    }

    return (
        <div>

            {isLoaded && <Modal width={"70%"} title={data?.title} visible={visible} onOk={() => null} footer={null} onCancel={() => setIsVisible(false)}>
                {/* {data?.upload_info_url && data?.upload_info_url.length > 0 && <><img
                    src={data?.upload_info_url[0]}
                    style={{ width: "100%" }}
                /></>} */}
                {data?.upload_info_url && data?.upload_info_url.length > 0 && <AliceCarousel
                              responsive={{
                                0: {
                                  items: 1,
                                },
                                1024: {
                                  items: 1,
                                  itemsFit: "contain",
                                },
                              }}
                              autoPlay={true}
                              autoWidth={true}
                              autoHeight={true}
                              autoPlayInterval={2000}
                              dotsDisabled={true}
                              mouseTracking
                              items={data?.upload_info_url.map((el, index) => {
                                return (
                                  <img
                                    src={el}
                                    onDragStart={handleDragStart}
                                    role="presentation"
                                    style={{
                                      width: "100%",
                                      height: "80vh",
                                      objectFit: "contain",
                                      backgroundColor:"white"
                                    }}
                                  />
                                );
                              })}
                            />}
                <p dangerouslySetInnerHTML={{ __html: data?.description }}></p>

            </Modal>}
        </div>
    )
}
